import _styled from "styled-components";
import Image from 'next/image';
import { BuildingOffice2Icon, MapPinIcon, UsersIcon } from '@heroicons/react/24/outline';
import Link from 'next/link';
import { customImageLoader } from '@restworld/utils-common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var InfoItem = function InfoItem(_ref) {
  var InfoItemIcon = _ref.InfoItemIcon,
      infoItemValue = _ref.infoItemValue;
  return /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [/*#__PURE__*/_jsx(InfoItemIcon, {
      className: "h-4 w-4 relative text-neutral-90"
    }), /*#__PURE__*/_jsxs(_StyledH, {
      children: [" ", infoItemValue]
    })]
  });
};

export function JobPositionsCardV2(_ref2) {
  var jobTitle = _ref2.jobTitle,
      businessName = _ref2.businessName,
      venueAddress = _ref2.venueAddress,
      openJobPositionsCount = _ref2.openJobPositionsCount,
      occupation = _ref2.occupation,
      _ref2$restaurantLogoU = _ref2.restaurantLogoUrl,
      restaurantLogoUrl = _ref2$restaurantLogoU === void 0 ? 'https://placehold.co/48x48?text=Logo' : _ref2$restaurantLogoU,
      restaurantHrefLink = _ref2.restaurantHrefLink,
      onClick = _ref2.onClick;
  return /*#__PURE__*/_jsx(_StyledLink, {
    href: restaurantHrefLink || '#!',
    onClick: onClick,
    children: /*#__PURE__*/_jsxs(_StyledDiv2, {
      children: [/*#__PURE__*/_jsxs(_StyledDiv3, {
        children: [!!restaurantLogoUrl && /*#__PURE__*/_jsx(_StyledSpan, {
          children: /*#__PURE__*/_jsx(_StyledImage, {
            fill: true,
            alt: "logo",
            src: restaurantLogoUrl,
            loader: customImageLoader
          })
        }), /*#__PURE__*/_jsx(_StyledH2, {
          children: jobTitle
        })]
      }), /*#__PURE__*/_jsxs(_StyledDiv4, {
        children: [!!businessName && /*#__PURE__*/_jsx(InfoItem, {
          InfoItemIcon: BuildingOffice2Icon,
          infoItemValue: businessName
        }), !!venueAddress && /*#__PURE__*/_jsx(InfoItem, {
          InfoItemIcon: MapPinIcon,
          infoItemValue: venueAddress
        }), !!occupation && /*#__PURE__*/_jsx(InfoItem, {
          InfoItemIcon: BuildingOffice2Icon,
          infoItemValue: occupation
        }), !!openJobPositionsCount && /*#__PURE__*/_jsx(InfoItem, {
          InfoItemIcon: UsersIcon,
          infoItemValue: openJobPositionsCount
        })]
      })]
    })
  });
}
export default JobPositionsCardV2;

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-positions-card-v2___StyledDiv",
  componentId: "sc-lmvk41-0"
})({
  "display": "flex",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "0.25rem"
});

var _StyledH = /*#__PURE__*/_styled("h5").withConfig({
  displayName: "job-positions-card-v2___StyledH",
  componentId: "sc-lmvk41-1"
})({
  "justifyContent": "flex-start",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(102 102 118 / var(--tw-text-opacity))"
});

var _StyledLink = /*#__PURE__*/_styled(Link).withConfig({
  displayName: "job-positions-card-v2___StyledLink",
  componentId: "sc-lmvk41-2"
})({
  "display": "inline-flex",
  "minWidth": "288px",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "alignSelf": "stretch",
  "borderRadius": "1rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
  "padding": "1.25rem",
  "outlineStyle": "solid",
  "outlineWidth": "1px",
  "outlineOffset": "-1px",
  "outlineColor": "#dedee1"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-positions-card-v2___StyledDiv2",
  componentId: "sc-lmvk41-3"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "alignSelf": "stretch"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-positions-card-v2___StyledDiv3",
  componentId: "sc-lmvk41-4"
})({
  "display": "inline-flex",
  "flexWrap": "wrap",
  "alignContent": "center",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "0.5rem",
  "alignSelf": "stretch",
  "overflow": "hidden",
  "paddingBottom": "1rem"
});

var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "job-positions-card-v2___StyledSpan",
  componentId: "sc-lmvk41-5"
})({
  "position": "relative",
  "height": "2rem",
  "width": "2rem"
});

var _StyledImage = /*#__PURE__*/_styled(Image).withConfig({
  displayName: "job-positions-card-v2___StyledImage",
  componentId: "sc-lmvk41-6"
})({
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "objectFit": "cover",
  "objectPosition": "center"
});

var _StyledH2 = /*#__PURE__*/_styled("h5").withConfig({
  displayName: "job-positions-card-v2___StyledH2",
  componentId: "sc-lmvk41-7"
})({
  "flex": "1 1 0%",
  "justifyContent": "center",
  "overflow": "hidden",
  "textOverflow": "ellipsis",
  "whiteSpace": "nowrap",
  "fontSize": "1.25rem",
  "lineHeight": "1.75rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-positions-card-v2___StyledDiv4",
  componentId: "sc-lmvk41-8"
})({
  "display": "inline-flex",
  "flexWrap": "wrap",
  "alignContent": "center",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "1rem",
  "alignSelf": "stretch",
  "paddingTop": "0.75rem",
  "paddingBottom": "1.5rem"
});